import React from 'react';
import {
  AppstoreOutlined,
  ArrowUpOutlined,
  PaperClipOutlined,
} from '@ant-design/icons';
import { Button } from 'antd';
import type { Task } from '../../../api/tasks/interface';
import styles from '../Chat.module.scss';
import MentionInput, { type MentionInputHandle } from '../MentionInput';

type MentionClickHandler = (type: 'file' | 'task', id: string) => void;

interface Props {
  mentionInputRef: React.RefObject<MentionInputHandle>;
  dossierId: string;
  sending: boolean;
  inputEmpty: boolean;
  tasks: Task[];
  onInputChange: (serialized: string) => void;
  onSend: () => void;
  onMentionClick: MentionClickHandler;
  onCommand: (cmd: 'upload' | 'note') => void;
}

const ChatComposer: React.FC<Props> = ({
  mentionInputRef,
  dossierId,
  sending,
  inputEmpty,
  tasks,
  onInputChange,
  onSend,
  onMentionClick,
  onCommand,
}) => (
  <div className={styles.inputCard}>
    <div className={styles.inputEditorRow}>
      <MentionInput
        ref={mentionInputRef}
        placeholder="Describe a task or ask a question – @ to include context"
        disabled={sending}
        dossierId={dossierId}
        tasks={tasks}
        onChange={onInputChange}
        onSend={onSend}
        onChipClick={onMentionClick}
        onCommand={onCommand}
      />
    </div>
    <div className={styles.inputActionsRow}>
      <Button
        type="text"
        size="small"
        icon={<PaperClipOutlined />}
        className={styles.inputPill}
        onClick={() => onCommand('upload')}
        disabled={sending}
      >
        Upload a file
      </Button>
      <Button
        type="text"
        size="small"
        icon={<AppstoreOutlined />}
        className={styles.inputPill}
        onClick={() => onCommand('note')}
        disabled={sending}
      >
        Add a note
      </Button>
      <span className={styles.inputSpacer} />
      <Button
        type="primary"
        shape="circle"
        icon={<ArrowUpOutlined />}
        className={styles.sendButton}
        onClick={onSend}
        disabled={sending || inputEmpty}
      />
    </div>
  </div>
);

export default ChatComposer;
